<template>
  <div class="estado-proceso">
    <Titulo titulo="Producto" />

    <div style="margin: 1% 8% 5% 10% !important">
      <h3 class="color-secundary mb-5">Detalle códigos y productos</h3>
      <div class="mr-5">
        <table-component :data="convenios" @click-event="clickEvent">
          <table-column
            slot="label"
            :label="'Código'"
            v-bind:value="'convenio'"
            :customClass="'text-center'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Modelo'"
            v-bind:value="'modelo'"
            :customClass="'text-center'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Producto'"
            v-bind:value="'nombre_convenio'"
            :customClass="'text-center'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Fecha Inicio'"
            v-bind:value="'fecha_inicio'"
            :customClass="'text-center'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Fecha Fin'"
            v-bind:value="'fecha_fin'"
            :customClass="'text-center'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Estado'"
            v-bind:value="'estado'"
          ></table-column>
          <table-column slot="label" :label="'Ver producto'" :icon="'fa'">
            <template
              slot="icon"
              :icon="'fa fa-search'"
              :class="'btn btn-sm btn-info'"
              :slug="'ver_productos'"
              :tooltip="'Ver productos'"
            ></template>
          </table-column>
        </table-component>
      </div>
    </div>

    <!-- Modal de ver productos -->
    <b-modal id="modal-1" title="Detalle producto" hide-footer size="xl">
      <h3 class="color-secundary ml-5">Producto</h3>
      <div class="m-5">
        <table-component :data="productos">
          <table-column
            slot="label"
            :label="'Código'"
            v-bind:value="'codigo'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Nombre producto'"
            v-bind:value="'producto'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Descripción cobro'"
            v-bind:value="'descripcion_valor_servicio_fianza'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Mora máx. reclamación con demanda'"
            v-bind:value="'mora_max_reclamacion_con_demanda'"
            :customClass="'text-center'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Mora máx. reclamación sin demanda'"
            v-bind:value="'mora_max_reclamacion_sin_demanda'"
            :customClass="'text-center'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Mora min. reclamación sin demanda'"
            v-bind:value="'mora_min_reclamacion_sin_demanda'"
            :customClass="'text-center'"
          ></table-column>
        </table-component>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Productos",
  data() {
    return {
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      convenioSeleccionado: null,
    };
  },
  computed: {
    ...mapGetters({
      //TablaProductos: "pages/TablaProductos",
      SelectFiltroTabla: "pages/SelectFiltroTabla",
      TablaVerProducto: "pages/TablaVerProducto",
    }),
    convenios() {
      return this.$store.getters["pages/convenios"];
    },
    productos() {
      return this.$store.getters["pages/productos"].filter(
        (producto) => producto.convenio == this.convenioSeleccionado
      );
    },
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  methods: {
    clickEvent(evento, name) {
      this.convenioSeleccionado = evento.convenio;
      this.$root.$emit("bv::show::modal", "modal-1", "#btnShow");
    },
  },
  mounted() {
    this.$store.dispatch("pages/fetchConvenios", {
      endpoint: "informes/convenio",
    });
    this.$store.dispatch("pages/fetchProductos", {
      endpoint: "informes/producto",
    });
  },
};
</script>